// extracted by mini-css-extract-plugin
export default {"variable-item":"VariablePopoverContent_variable-item__79SZB","delete-icon":"VariablePopoverContent_delete-icon__G1LhC"};